import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  constructor(props) {
    super(props)
  }
  state = {

  }
  changeMainState = (mainTabState) => {
    // const img = this.props
    if (mainTabState == 1) {
      return "/img/activity/22-11-18mar/na2.png"
    } else if (mainTabState == 2) {
      return "/img/activity/22-11-18mar/na2.png"
    } else if (mainTabState == 3) {
      return "/img/activity/22-11-18mar/na2.png"
    } else {
      return ""
    }
  }
  changeSecondState = (secondTabState) => {
    if (secondTabState) {
      return this.props.activeBg
    } else {
      return this.props.inActiveBg
    }
  }
  render() {
    const {
      lang, mainTabState,
      secondTabState, onChangeSecondState,
      onChangeMainState, secondIsShow, tabBg,
      activeBg
    } = this.props

    return (
      <div className='nt-tab-wrap'>

        {/* 主tab栏 */}
        <div className="main-tab">
          <div className={`nt-tab-top`}
            // style={{ backgroundImage: `url(${this.changeMainState(mainTabState)})` }}
            style={{ backgroundImage: `url(${tabBg})` }}
          >
            <div
              className={`nt-tab-top-item ${mainTabState == 1 ? 'nt-tab-top-item-active' : ''}`}
              onClick={() => { onChangeMainState(1) }}
              style={{ backgroundImage: `url(${mainTabState == 1 ? activeBg : ""})` }}
            >
              {lang && lang.rank}
            </div>
            <div
              className={`nt-tab-top-item ${mainTabState == 2 ? 'nt-tab-top-item-active' : ''}`}
              onClick={() => { onChangeMainState(2) }}
              style={{ backgroundImage: `url(${mainTabState == 2 ? activeBg : ""})` }}
            >
              {lang && lang.room}
            </div>
            <div
              className={`nt-tab-top-item ${mainTabState == 3 ? 'nt-tab-top-item-active' : ''}`}
              onClick={() => { onChangeMainState(3) }}
              style={{ backgroundImage: `url(${mainTabState == 3 ? activeBg : ""})` }}
            >
              {lang && lang.reward}
            </div>
          </div>
        </div>

        {/* 副tab栏 */}
        <div className="nt-tab-bottom" style={{ display: `${secondIsShow ? "flex" : "none"}` }}>
          <div className={`nt-tab-bottom-item ${secondTabState == 1 ? 'nt-tab-bottom-item-active' : ''}`}
            style={{ backgroundImage: `url(${this.changeSecondState(secondTabState == 1)})` }}
            onClick={() => { onChangeSecondState(1) }}
          >
            {lang && lang.world}
          </div>
          <div className={`nt-tab-bottom-item ${secondTabState == 2 ? 'nt-tab-bottom-item-active' : ''}`}
            style={{ backgroundImage: `url(${this.changeSecondState(secondTabState == 2)})` }}
            onClick={() => onChangeSecondState(2)}
          >
            {lang && lang.nation}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/Tab/index.js